import React, { Component } from 'react'
import Button from 'components/theme/Button'
import Fields from './Fields'
import { withStyles } from '@material-ui/core'
import language from 'utils/vast-languagepack'

export default withStyles(theme => ({
  button: { padding: '6px 45px', margin: '0 10px' },
}))(
  class Mobile extends Component {
    state = {
      selected: 'email',
    }

    render() {
      const { classes } = this.props

      return (
        <div style={{ width: '100%' }}>
          <div style={{ textAlign: 'center', width: '100%', marginBottom: 33 }}>
            <Button
              className={classes.button}
              color="secondary"
              variant={
                this.state.selected === 'email' ? 'contained' : 'outlined'
              }
              onClick={() => this.setState({ selected: 'email' })}
            >
              {language.contacts.add.mobileEmailButton}
            </Button>
            <Button
              className={classes.button}
              color="secondary"
              variant={
                this.state.selected === 'phone' ? 'contained' : 'outlined'
              }
              onClick={() => this.setState({ selected: 'phone' })}
            >
              {language.contacts.add.mobilePhoneButton}
            </Button>
          </div>
          {this.state.selected === 'email' ? (
            <Fields fieldType="email" />
          ) : (
            <Fields fieldType="phones" />
          )}
        </div>
      )
    }
  }
)
